import { gql } from '@lcs/shared/api';

export const getExtensionDetail = gql`
   query GetExtensionDetail($id: UInt!) {
      extension(id: $id) {
         extensionId
         name
         shortName
         number
         type
         timeZoneId
         displayTimeZone
         mailboxId
         isArchived
         adminNote {
            noteId
            accountId
            notes
            isSystemNote
         }
         extensionNote {
            noteId
            accountId
            extensionId
            notes
            isSystemNote
         }
         location {
            locationId
            name
            houseNumber
            directionalPrefix
            streetName
            streetNameSuffix
            directionalPostfix
            city
            state
            postalCode
            country
            timeZoneId
         }
         extensionType {
            displayName
         }
         createUser {
            userId
            name
         }
         createDate
         updateUser {
            userId
            name
         }
         updateDate
         account {
            accountId
            name
            timeZoneId
            domain
            operatorExtension {
               extensionId
               name
               number
            }
            extensionGroupsConnection {
               items {
                  extensionGroupId
                  name
                  description
               }
            }
            extensionsConnection {
               items {
                  extensionId
                  isArchived
                  name
                  number
                  type
               }
            }
            isOtrEnabled
            isCallRecordingFeatureEnabled
            defaultAreaCode
         }
         usersConnection {
            items {
               userId
               name
            }
         }
         phonesConnection {
            items {
               phoneId
               phoneType
               handsetIpei
               baseStationHandsetsConnection {
                  items {
                     baseStationHandsetId
                     phoneId
                     sortId
                     device {
                        deviceId
                        deviceTypeId
                        macAddress
                        description
                     }
                  }
               }
               devicesConnection {
                  items {
                     deviceId
                     deviceTypeId
                     macAddress
                  }
               }
               sipUsersConnection {
                  items {
                     sipUserId
                     userName
                     isHacked
                     isFraud
                     phone {
                        phoneId
                        phoneType
                        devicesConnection {
                           items {
                              deviceId
                              deviceTypeId
                              macAddress
                           }
                        }
                     }
                  }
               }
            }
         }
         faxesConnection {
            items {
               faxId
               extensionId
               faxTypeId
               faxStatusId
               from
               to
               processedTime
            }
         }
         faxEmailAddressesConnection {
            items {
               faxEmailAddressId
               emailAddress
               extensionId
            }
         }
         departmentExtensionsConnection {
            items {
               departmentExtensionId
               extensionId
               departmentId
               department {
                  departmentId
                  name
                  isActive
                  accountId
               }
            }
         }
         extensionPagingGroup {
            extensionId
            extensionPagingGroupId
            extensionPagingGroupExtension {
               name
               number
            }
            pagingGroupMembersConnection {
               items {
                  pagingGroupMemberId
                  extensionPagingGroupId
                  extensionId
                  extension {
                     extensionId
                     name
                     number
                  }
               }
            }
            pagingGroupExtensionGroupsConnection {
               items {
                  pagingGroupExtensionGroupId
                  extensionPagingGroupId
                  extensionGroupId
                  extensionGroup {
                     extensionGroupId
                     name
                     description
                     extensionGroupExtensionsConnection {
                        items {
                           extension {
                              extensionId
                              name
                              number
                           }
                        }
                     }
                  }
               }
            }
         }
         extensionPhone {
            extensionPhoneId
            displayName
            ringTimeout
            enableDtmf
            secondsToWait
            dtmfToPlay
            isOtrEnabled
            isAutoAnswer
            isRingAllPhones
            isAutoAnswerEnabled
            defaultAreaCode
            office
            autoAnswerPhone {
               phoneId
               phoneType
               extensionId
               sipUsersConnection {
                  items {
                     sipUserId
                     userName
                  }
               }
               devicesConnection {
                  items {
                     deviceId
                     macAddress
                     description
                  }
               }
            }
            extension {
               account {
                  defaultAreaCode
               }
            }
            defaultPhoneNumber {
               phoneNumberId
               displayName
               phoneNumber
            }
            dndStatus
            forwardExtension {
               extensionId
               name
               number
            }
            forwardExternalNumber
            routeBusyExtension {
               extensionId
               name
               number
            }
            routeBusyNullAction
            routeNoAnswerExtension {
               extensionId
               name
               number
            }
            routeNoAnswerNullAction
            phonesConnection {
               items {
                  extensionId
                  phoneId
                  phoneType
                  handsetIpei
                  sipUsersConnection {
                     items {
                        sipUserId
                        userName
                        hashPassword
                        phoneId
                        accountId
                     }
                  }
                  devicesConnection {
                     items {
                        deviceId
                        phoneId
                     }
                  }
                  baseStationHandsetsConnection {
                     items {
                        baseStationHandsetId
                        phoneId
                        sortId
                        device {
                           deviceId
                           deviceTypeId
                           macAddress
                           description
                        }
                     }
                  }
               }
            }
            extensionSuperviseesConnection {
               items {
                  extensionSuperviseeId
                  supervisorExtensionId
                  superviseeExtension {
                     extensionId
                     name
                     number
                     type
                  }
               }
            }
            extensionGroupSuperviseesConnection {
               items {
                  extensionGroupSuperviseeId
                  supervisorExtensionId
                  superviseeExtensionGroup {
                     extensionGroupId
                     description
                     name
                  }
               }
            }
         }
         extensionHuntGroup {
            extensionHuntGroupId
            extensionId
            displayName
            ringTimeout
            callerIdOverride
            routeBusyExtension {
               extensionId
               name
               number
               type
            }
            routeNoAnswerExtension {
               extensionId
               name
               number
               type
            }
            isRouteBusyVoicemailOnly
            isRouteNoAnswerVoicemailOnly
            routeBusyNullAction
            routeNoAnswerNullAction
            huntGroupMembersConnection {
               items {
                  huntGroupMemberId
                  extensionHuntGroupId
                  extension {
                     extensionId
                     name
                     number
                  }
               }
            }
            extensionGroupHuntGroupMembersConnection {
               items {
                  huntGroupExtensionGroupId
                  huntGroupExtensionId
                  extensionGroupId
                  extensionGroup {
                     name
                     description
                  }
               }
            }
         }
         extensionAutoAttendant {
            extensionAutoAttendantId
            timeoutSeconds
            timeoutExtension {
               extensionId
               name
               number
               type
            }
            firstPromptNotSkippable
            timeoutNullAction
            isTimeoutVoicemailOnly
            autoAttendantPromptsConnection {
               items {
                  autoAttendantPromptId
                  extensionAutoAttendantId
                  prompt {
                     promptId
                     name
                     file {
                        fileToken
                     }
                  }
                  sortId
                  extensionAutoAttendant {
                     extensionAutoAttendantId
                     extensionId
                  }
               }
            }
            autoAttendantKeysConnection {
               items {
                  autoAttendantKeyId
                  extensionAutoAttendantId
                  routeToExtension {
                     extensionId
                     name
                     number
                     type
                  }
                  keyNumber
                  voiceMailOnly
                  routeToNullAction
                  extensionAutoAttendant {
                     extensionAutoAttendantId
                     extensionId
                  }
               }
            }
         }
         extensionExternalForward {
            extensionExternalForwardId
            extension {
               extensionId
               name
               number
            }
            forwardToNumber
            isPassthroughOriginalCallerId
            dtmf
            pauseSeconds
            isDtmf
         }
         extensionMailbox {
            extensionMailboxId
            extension {
               extensionId
               name
               number
            }
         }
         extensionQueue {
            extensionQueueId
            queueStrategyId
            wrapUpTime
            announcementFrequency
            holdMusicPrompt {
               promptId
               name
            }
            isAnnounceWaitTime
            isAnnounceQueueCount
            isAnnounceCallback
            isCallBackAvailable
            callersNeededForCallback
            callBackType
            holdTimeNeededForCallback
            callbackPrompt {
               promptId
               name
            }
            exitRouteToExtension {
               extensionId
               name
               number
               type
            }
            exitRouteVoicemailOnly
            hasPreventEmptyQueue
            queueEmptyExitRouteToExtension {
               extensionId
               name
               number
               type
            }
            queueEmptyExitNullAction
            periodicAnnouncementFrequency
            queueMembersConnection {
               items {
                  queueMemberId
                  extensionQueueId
                  extensionQueue {
                     extensionQueueId
                     extensionId
                     extension {
                        extensionId
                        name
                        number
                     }
                  }
                  agentExtension {
                     extensionId
                     name
                     number
                  }
                  isLoggedIn
                  agentStatus
                  endWrapUpTime
                  queueExtensionGroupId
               }
            }
            queueExtensionGroupMembersConnection {
               items {
                  queueExtensionGroupId
                  queueExtensionId
                  extensionGroupId
                  extensionGroup {
                     name
                     description
                  }
                  extensionQueue {
                     extensionQueueId
                     extensionId
                     extension {
                        extensionId
                        name
                        number
                     }
                  }
               }
            }
            queuePeriodicAnnouncementsConnection {
               items {
                  queuePeriodicAnnouncementId
                  extensionQueueId
                  sortOrder
                  prompt {
                     promptId
                     name
                     file {
                        fileToken
                     }
                  }
               }
            }
         }
         extensionFax {
            extensionFaxId
            extension {
               extensionId
               name
               number
            }
            defaultPhoneNumber {
               phoneNumberId
               displayName
               phoneNumber
            }
            emailAddress
         }
         extensionFmFm {
            extensionFmFmId
            extension {
               extensionId
               name
               number
            }
            finalDestinationExtension {
               extensionId
               name
               number
               type
            }
            defaultPhoneNumber {
               phoneNumberId
               phoneNumber
               displayName
            }
            isFinalDestinationVoicemail
            finalDestinationPhoneNumber
            isIgnoreForward
            isGreetingDisabled
            isSendOriginalCallerId
            defaultPhoneNumber {
               phoneNumberId
               displayName
               phoneNumber
            }
            defaultPhoneNumberId
            fmFmStepsConnection {
               items {
                  fmFmStepId
                  timeout
                  sequence
                  fmFmStepPhoneNumbersConnection {
                     items {
                        fmFmStepPhoneNumberId
                        fmFmStepId
                        phoneNumber
                     }
                  }
                  fmFmStepExtensionsConnection {
                     items {
                        fmFmStepExtensionId
                        fmFmStepId
                        extension {
                           extensionId
                           name
                           number
                        }
                     }
                  }
               }
            }
         }
         timeBasedRoutesConnection {
            items {
               timeBasedRouteId
               extensionId
               startDate
               endDate
               startTime
               endTime
               priorityId
               comment
               isActiveMonday
               isActiveTuesday
               isActiveWednesday
               isActiveThursday
               isActiveFriday
               isActiveSaturday
               isActiveSunday
               routeExtensionNullAction
               routeExtension {
                  extensionId
                  name
                  number
               }
            }
         }
         mailbox {
            emailAddress
            discardAudioAfterEmail
            markReadAfterEmail
            isInNameDirectory
            sayCallerId
            mailboxId
            password
            unavailablePromptId2
            unavailablePrompt {
               promptId
               name
               file {
                  fileToken
               }
            }
            temporaryUnavailablePromptId
            temporaryUnavailablePrompt {
               promptId
               name
               file {
                  fileToken
               }
            }
            operatorExtensionId
            mailboxOperatorExtension {
               extensionId
               name
               number
            }
            namePromptId
            namePrompt {
               promptId
               name
               file {
                  fileToken
               }
            }
            busyPromptId
            busyPrompt {
               promptId
               name
               file {
                  fileToken
               }
            }
            mailboxMessagesConnection {
               items {
                  mailboxMessageId
                  timestamp
                  sender
                  isRead
                  mailboxFolderId
                  isArchived
                  file {
                     fileToken
                  }
               }
            }
         }

         autoAttendantsUsingForTimeoutConnection {
            items {
               extensionAutoAttendantId
               extension {
                  extensionId
                  name
                  number
               }
            }
         }
         fmFmsUsingForFinalDestinationConnection {
            items {
               extensionFmFmId
               extension {
                  extensionId
                  name
                  number
               }
            }
         }
         queuesUsingForExitRouteConnection {
            items {
               extensionQueueId
               extension {
                  extensionId
                  name
                  number
               }
            }
         }
         huntGroupsUsingForRouteBusyConnection {
            items {
               extensionHuntGroupId
               extension {
                  extensionId
                  name
                  number
               }
            }
         }
         huntGroupsUsingForRouteNoAnswerConnection {
            items {
               extensionHuntGroupId
               extension {
                  extensionId
                  name
                  number
               }
            }
         }
      }
   }
`;
